export default "__VITE_ASSET__4af27e44__"